module.exports = __webpack_public_path__ + "img/agent-digital.fd9df31b.jpg";